import * as React from 'react';
import { SVGProps } from 'react';

const IconMagicSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path d="M8.08 5.92 11 7 8.08 8.08 7 11 5.92 8.08 3 7l2.92-1.08L7 3l1.08 2.92ZM4.175 2.825 6 3.5l-1.825.675L3.5 6l-.675-1.825L1 3.5l1.825-.675L3.5 1l.675 1.825Z" />
  </svg>
);
export default IconMagicSizeXs;
